import { FormSelectedSlot } from '../../../types/formSelectedSlots';
import { OnError } from '../../types';
import { FormApiContext, withErrorBoundary } from '../utils';
import { ListAddOnGroupsByServiceIdResponse } from '@wix/ambassador-bookings-services-v2-service/types';
import { listAddOnGroupsByServiceId } from '@wix/ambassador-bookings-services-v2-service/http';
import { ServerErrorType } from '../../../types/errors';

export type GetListAddonsGroupsDataArgs = {
  formSelectedSlot: FormSelectedSlot;
  onError?: OnError;
};

export const getListAddonsGroups = async ({
  formSelectedSlot,
  onError,
  httpClient,
  reportError,
}: GetListAddonsGroupsDataArgs &
  FormApiContext): Promise<ListAddOnGroupsByServiceIdResponse> => {
  const { data, error } = await withErrorBoundary(
    {
      fn: async () => {
        const serviceId = formSelectedSlot.nestedSlots[0].serviceId;
        const response = await httpClient.request(
          listAddOnGroupsByServiceId({
            serviceId,
          }),
        );
        return response.data;
      },
      mapError: (e) => ({
        error: ServerErrorType.INVALID_ADDONS_DATA,
        shouldReport: true,
      }),
      fallback: {
        addOnGroupsDetails: [],
      },
    },
    reportError,
  );

  if (error) {
    onError?.(error);
  }

  return data!;
};
